module.exports = __webpack_public_path__ + "static/IMG_0060.ba2d0ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/examples/IMG_0060.png
// module id = 572
// module chunks = 35783957827783